/*
    This utility function adds the custom event listener for navbar expand and collapsed event
*/

export const addSideNavIsExpandEventListener = () => {
  const contentDiv = document.getElementById('main');

  // Adding event listener to expand and collapse the navbar
  window.addEventListener('sideNavExpanded', e => {
    if (e.currentTarget.origin.includes(window.location.origin)) {
      if (e.detail.isExpanded) {
        // Change class to 'expanded'
        contentDiv.className = 'router-outlet globalnav-expanded';
      } else {
        // Change class to 'collapsed'
        contentDiv.className = 'router-outlet globalnav-notexpanded';
      }
    } else {
      console.log('origin does not match');
    }
  });
};
